// extracted by mini-css-extract-plugin
export default {"skippedStep":"InternshipProcess_skippedStep__v58b-","blurredStep":"InternshipProcess_blurredStep__T0L-A"};